"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatePicker = exports.isoDateFormat = exports.displayDateFormat = void 0;
var pickers_1 = require("@material-ui/pickers");
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var react_1 = require("react");
var DatePicker_static_1 = require("./DatePicker.static");
var DatePicker_style_1 = __importDefault(require("./DatePicker.style"));
function isSameDate(a, b) {
    return (a === null || a === void 0 ? void 0 : a.isSame(b, 'day')) || false;
}
exports.displayDateFormat = 'MMM D, YYYY';
exports.isoDateFormat = 'YYYY-MM-DD';
function useDatePicker(_a) {
    var value = _a.value, offset = _a.offset, onChange = _a.onChange, inputTextFieldProps = __rest(_a, ["value", "offset", "onChange"]);
    var _b = __read((0, react_1.useState)(null), 2), anchor = _b[0], setAnchorEl = _b[1];
    var inputRef = (0, react_1.useRef)(null);
    var _c = __read((0, react_1.useState)(false), 2), isDatePickerVisible = _c[0], setIsDatePickerVisible = _c[1];
    var selectedDate = value ? (0, moment_1.default)(value).startOf('day') : undefined;
    var setSelectedDate = function (date) {
        return onChange(date ? date.clone().endOf('day').utc().toISOString() : undefined);
    };
    var offsetDate = (0, moment_1.default)(offset);
    var minDate = offsetDate.clone().add(1, 'day').startOf('day');
    var maxDate = offsetDate.clone().add(1, 'year').startOf('day');
    var staticPickerOptions = [3, 6, 12].map(function (month) { return ({
        text: DatePicker_static_1.localText.month(month),
        date: offsetDate.clone().add(month, 'months').startOf('day'),
    }); });
    var menuOptions = (0, lodash_1.map)(staticPickerOptions, function (option) { return (__assign(__assign({}, option), { onClick: function () {
            setSelectedDate(option.date);
            setAnchorEl(null);
        }, selected: isSameDate(option.date, selectedDate) })); });
    var pickerProps = (0, pickers_1.useStaticState)({
        value: selectedDate,
        onChange: function (date) {
            setSelectedDate(date);
            setAnchorEl(null);
        },
    }).pickerProps;
    var openPopper = function () {
        setIsDatePickerVisible(false);
        setAnchorEl(inputRef.current);
    };
    var openDatePicker = function () {
        !selectedDate && setSelectedDate(minDate);
        setIsDatePickerVisible(true);
    };
    var textFieldProps = __assign(__assign({}, inputTextFieldProps), { inputRef: inputRef, value: (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.format(exports.displayDateFormat)) || '', focused: !!anchor, onFocus: openPopper, onChange: lodash_1.noop });
    var isExactDateSelected = !!selectedDate && !(0, lodash_1.some)(staticPickerOptions, function (option) { return isSameDate(option.date, selectedDate); });
    return {
        classes: (0, DatePicker_style_1.default)(),
        isDatePickerVisible: isDatePickerVisible,
        isExactDateSelected: isExactDateSelected,
        openDatePicker: openDatePicker,
        menuOptions: menuOptions,
        pickerProps: __assign(__assign({}, pickerProps), { minDate: minDate, maxDate: maxDate, disablePast: true, allowKeyboardControl: false }),
        textFieldProps: textFieldProps,
        chevronProps: {
            isExpanded: !!anchor,
            onClick: openPopper,
        },
        popoverProps: {
            disableRestoreFocus: true,
            anchorElement: anchor,
            closePopover: function () { return setAnchorEl(null); },
        },
    };
}
exports.useDatePicker = useDatePicker;
